import Translatable from "../translatable_text/Translatable";

function SocialLinks() {
  return (
<section
      className="work-minimal py-20 border-t border-gray-300 section-padding wow d-rotate"
      data-scroll-index="4"
    >
      <div className="sec-head mb-12 ">
        <h3 className=" rotate-text">
          <Translatable>Our</Translatable>{" "}
          <span className="font-light"><Translatable>Social Media GCAD</Translatable></span>
        </h3>
      </div>
      <div className="gallery flex flex-wrap gap-4">
        <div className="items w-full md:w-[calc(50%-10px)] rotate-text">
          <div className="item mb-5">
            <div className="img relative">
              <img
                style={{ height: 200, objectFit: 'cover' }} 
                src="/light/assets/imgs/linkedin-colored.webp"
                alt=""
                loading="lazy"
                decoding="async"
              />
              <div className="cont flex items-center justify-center text-white">
                <p className="underline hover:underline transition-colors duration-200">
                  <a target="_blank" href="https://www.linkedin.com/company/gcad-sa/posts/?feedView=all">visit linkedin</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="items w-full md:w-[calc(50%-10px)] rotate-text">
          <div className="item mb-5">
            <div className="img relative">
              <img
                style={{ height: 200, objectFit: 'cover' }} 
                src="/light/assets/imgs/twitter-1.webp"
                alt=""
                loading="lazy"
                decoding="async"
              />
              <div className="cont flex items-center justify-center text-white">
                <p className="underline hover:underline transition-colors duration-200">
                  <a target="_blank" href="https://x.com/GCAD_SA">Visit twitter</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="items w-full rotate-text">
          <div className="item">
            <div className="img relative">
              <img
                style={{ height: 400, objectFit: 'cover' }} 
                src="/light/assets/imgs/youtube-dark.webp"
                alt=""
                loading="lazy"
                decoding="async"
              />
              <div className="cont flex items-center justify-center text-white">
                <p className="underline hover:underline transition-colors duration-200">
                  <a target="_blank" href="https://www.youtube.com/@gcad_sa">youtube channel</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialLinks;
